import { Box, Button, Input, InputLabel, Paper, TextField, Tooltip } from '@mui/material'
import '../kytManualCheck.scss'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfoIcon from '@mui/icons-material/Info'
import { RenderTooltip } from '../../../../components/utilities/RenderTooltip'

const SwiftDetails = ({ setPaymentDetails, isReset, setIsReset }) => {
  const [accountNumber, setAccountNumber] = useState('')
  const [accountType, setAccountType] = useState('')
  const [bankName, setBankName] = useState('')
  const [swiftCode, setSwiftCode] = useState('')
  const [name, setName] = useState('')
  const [specialInstructions, setSpecialInstructions] = useState('')

  const { t } = useTranslation(['common', 'messages'])
  const [change, setChange] = useState(false)

  useEffect(() => {
    if (change) {
      const body = {
        method: 'SWIFT',
        ...(accountNumber && { accountNumber }),
        ...(accountType && { accountType }),
        ...(bankName && { bankName }),
        ...(swiftCode && { swiftCode }),
        ...(name && { name }),
        ...(specialInstructions && { specialInstructions }),
      }

      setPaymentDetails(body)
      setChange(false)
    }
  }, [change])

  useEffect(() => {
    if (isReset) {
      setAccountNumber('')
      setAccountType('')
      setBankName('')
      setSwiftCode('')
      setName('')
      setSpecialInstructions('')
      setIsReset(false)
    }
  }, [isReset])

  return (
    <Paper elevation={0} className="kyt-form">
      <Box className="kyt-form-pair">
        <Box className="kyt-form-pair-label">
          <InputLabel>{t('common:accountNumber')}</InputLabel>
          <RenderTooltip title={'Bank account number.'} />
        </Box>
        <TextField
          fullWidth
          size="small"
          type="text"
          value={accountNumber}
          onChange={(event) => {
            setAccountNumber(event.target.value)
            setChange(true)
          }}
          placeholder={`${t('common:insert')} ${t('common:accountNumber')} ${t('here')}`}
        />
      </Box>
      <Box className="kyt-form-pair">
        <Box className="kyt-form-pair-label">
          <InputLabel>{t('common:accountType')}</InputLabel>
          <RenderTooltip title={'Bank account type. E.g. Checking, Savings etc.'} />
        </Box>
        <TextField
          fullWidth
          size="small"
          type="text"
          value={accountType}
          onChange={(event) => {
            setAccountType(event.target.value)
            setChange(true)
          }}
          placeholder={`${t('common:insert')} ${t('common:accountType')} ${t('here')}`}
        />
      </Box>
      <Box className="kyt-form-pair">
        <Box className="kyt-form-pair-label">
          <InputLabel>{t('common:bankName')}</InputLabel>
          <RenderTooltip title={'Name of the bank.'} />
        </Box>

        <TextField
          fullWidth
          size="small"
          type="text"
          value={bankName}
          onChange={(event) => {
            setBankName(event.target.value)
            setChange(true)
          }}
          placeholder={`${t('common:insert')} ${t('common:bankName')} ${t('here')}`}
        />
      </Box>
      <Box className="kyt-form-pair">
        <Box className="kyt-form-pair-label">
          <InputLabel>{t('common:swiftCode')}</InputLabel>
          <RenderTooltip title={'SWIFT code of the financial institution.'} />
        </Box>

        <TextField
          fullWidth
          size="small"
          type="text"
          value={swiftCode}
          onChange={(event) => {
            setSwiftCode(event.target.value)
            setChange(true)
          }}
          placeholder={`${t('common:insert')} ${t('common:swiftCode')} ${t('here')}`}
        />
      </Box>
      <Box className="kyt-form-pair">
        <Box className="kyt-form-pair-label">
          <InputLabel>{t('common:name')}</InputLabel>
          <RenderTooltip title={'Name of the account holder.'} />
        </Box>
        <TextField
          fullWidth
          size="small"
          type="text"
          value={name}
          onChange={(event) => {
            setName(event.target.value)
            setChange(true)
          }}
          placeholder={`${t('common:insert')} ${t('common:name')} ${t('here')}`}
        />
      </Box>
      <Box className="kyt-form-pair">
        <Box className="kyt-form-pair-label">
          <InputLabel>{t('common:specialInstructions')}</InputLabel>
          <RenderTooltip title={'Special instructions to be specified if any.'} />
        </Box>
        <TextField
          fullWidth
          size="small"
          type="text"
          value={specialInstructions}
          onChange={(event) => {
            setSpecialInstructions(event.target.value)
            setChange(true)
          }}
          placeholder={`${t('common:insert')} ${t('common:specialInstructions')} ${t('here')}`}
        />
      </Box>
    </Paper>
  )
}

export default SwiftDetails
